import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { strings } from '../../../resources/strings';
import { ReportService } from '../ReportService';
import { GenerateLensSeparationListReportInput } from './GenerateLensSeparationListReportInput';

export class GenerateLensSeparationListReportService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  handlePdf = (input: GenerateLensSeparationListReportInput) => {
    this.http.postToDownloadFile<GenerateLensSeparationListReportInput>(
      `${this.baseUrlSislogApi}/v2/report-lens-separation-list/pdf`,
      input
    ).then(result => {
      this.report.openPdf(result);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingReport);
    });
  }

  handleCsv = (input: GenerateLensSeparationListReportInput) => {
    this.http.postToDownloadFile<GenerateLensSeparationListReportInput>(
      `${this.baseUrlSislogApi}/v2/report-lens-separation-list/csv`,
      input
    ).then(result => {
      this.report.download(result, `${strings.LensSeparationList}.csv`);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
    });
  }
}